<template>
	<Popper
		v-click-outside="closePopover"
		:isVisible="popoverVisible"
		placement="bottom-end"
		@keyup.escape="closePopover"
	>
		<BaseTooltip :placement="tooltipPlacement" :text="tooltipText" :enabled="Boolean(tooltipText?.length)">
			<button @click="popoverVisible = !popoverVisible">
				<slot :popoverVisible="popoverVisible" />
			</button>
		</BaseTooltip>

		<template #popup>
			<BasePopover style="width: 260px" data-test="collection-select-popover">
				<template #header>
					<h3 class="mx-12 pb-8 mt-4">{{ title }}</h3>
				</template>
				<hr class="border-gray-650 my-0" />

				<CollectionSelectWorkspaceItem
					v-for="{workspace} of availableWorkspaces"
					:key="workspace.id"
					:workspace="workspace"
					class="workspaces"
					:selectedCollection="selectedCollection"
					:popoverVisible="popoverVisible"
					:showConfirmation="showConfirmationButton"
					@select="selectCollection"
				/>
				<template v-if="showConfirmationButton && selectedCollection.id" #footer>
					<div class="flex justify-end mt-4 mx-4">
						<button type="button" class="link-gray mr-16" @click="closePopover">Cancel</button>
						<button type="button" class="button-blue text-strong-base" @click="confirmSelection">
							<slot name="cta" />
						</button>
					</div>
				</template>
			</BasePopover>
		</template>
	</Popper>
</template>

<script>
import Popper from 'shared/components/Popper.vue'
import CollectionSelectWorkspaceItem from 'shared/components/CollectionSelectWorkspaceItem.vue'

export default {
	components: {
		Popper,
		CollectionSelectWorkspaceItem,
	},
	props: {
		tooltipText: {
			type: String,
			default: 'Move selected',
		},
		tooltipPlacement: {
			type: String,
			default: 'bottom',
		},
		title: {
			type: String,
			default: 'Move to folder',
		},
		resetSelectionOnClose: Boolean,
		showConfirmationButton: Boolean,
	},
	emits: ['select'],
	data() {
		return {
			popoverVisible: false,
			selectedCollection: {},
		}
	},
	computed: {
		availableWorkspaces() {
			if (!this.$store.user) return []
			if (!this.$store.userWorkspaces) return []
			// if the user has a BrowserStack workspace, but has browserstackProductAccess false, do not display it in the dropdown
			if (this.$store.user.browserstackProductAccess) return this.$store.userWorkspaces
			return this.$store.userWorkspaces.filter(({workspace}) => !workspace.browserstackId)
		},
	},
	watch: {
		availableWorkspaces: {
			immediate: true,
			handler(workspaces) {
				if (!workspaces?.length) return
				if (this.selectedCollection.id) return
				if (!this.$store.collection?.id) return
				this.selectCollection(this.$store.collection)
			},
		},
	},
	mounted() {
		// whenever the confirm selection button should not be shown (ie: in the local session)
		// then we default to automatically select the current workspace collection
		if (!this.showConfirmationButton) this.selectCollection(this.$store.collection)
	},
	methods: {
		selectCollection(collection) {
			this.selectedCollection = collection
			if (!this.showConfirmationButton) this.confirmSelection()
		},
		confirmSelection() {
			this.$emit('select', this.selectedCollection)
			this.closePopover()
		},
		closePopover() {
			if (this.resetSelectionOnClose) this.selectedCollection = {}
			this.popoverVisible = false
		},
	},
}
</script>

<style scoped>
.workspaces:last-of-type hr {
	display: none;
}
</style>
